import i18next from 'i18next';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { displayIdNumber } from 'dashboard/components/ChecksTable/computeCheckMetadata/utils';
import { IdNumberFormatInconsistencyDetection } from 'dashboard/models/check';
import { COUNTRIES, CountryCode } from 'lib/constants/locales';
import { tForGovernmentId } from 'lib/governmentId';

export const computeIdNumberFormatInconsistencyDetectionMetadata = (
  check: IdNumberFormatInconsistencyDetection,
  hasPermissionVerificationGovIdNumberView: boolean,
): CheckMetadata => {
  const {
    'identification-number': identificationNumber,
    'country-code': countryCode,
    'detected-id-class': detectedIdClass,
    'id-number-name': idNumberName,
  } = check.metadata || {};

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Issuing Country',
        value: COUNTRIES[countryCode as CountryCode],
      },
      {
        label: 'Detected ID Type',
        value: countryCode
          ? tForGovernmentId(
              i18next.getFixedT('en-US'),
              ['government-id.title'],
              countryCode,
              detectedIdClass,
            )
          : '',
      },
      {
        label: 'ID Number Name',
        value: idNumberName,
      },
      {
        label: 'Extracted ID Number',
        value: displayIdNumber(
          identificationNumber || '',
          hasPermissionVerificationGovIdNumberView,
        ),
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
